import { PatientInstructionOutputDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { APP_ROUTES } from '@/src/constants';

export type Instruction = PatientInstructionOutputDTO & {
  url?: string;
  shouldTranslate?: boolean;
};

export type InstructionSection = {
  sectionTitle?: string;
  instructionItems: Instruction[];
};

export const TLC_INSTRUCTION: Instruction = {
  id: 'agreements_cgu_and_tlc',
  instruction: 'agreements_cgu_and_tlc',
  url: `${APP_ROUTES.POLICIES.CGUS}`,
  shouldTranslate: true,
};
